import { observable } from 'mobx';

export interface IInStorePickupBanner {
    banner_image_src: string;
    banner_image_alt: string;
    learn_more: string;
    learn_more_link: string;
    shop_now: string;
    shop_now_link: string;
    subtitle: string;
    title: string;
}

export class InStorePickupBanner implements IInStorePickupBanner {
    @observable public banner_image_src: string;
    @observable public banner_image_alt: string;
    @observable public learn_more: string;
    @observable public learn_more_link: string;
    @observable public shop_now: string;
    @observable public shop_now_link: string;
    @observable public subtitle: string;
    @observable public title: string;

    /* eslint-disable @typescript-eslint/no-explicit-any */
    public static fromJson(data: any): IInStorePickupBanner {
        const banner = new InStorePickupBanner();

        banner.banner_image_src = data?.banner_image?.images?.desktop_image?.fid?.uri;
        banner.banner_image_alt = data?.banner_image?.images?.alt_value;
        banner.learn_more = data?.learn_more?.textfield;
        banner.learn_more_link = data?.learn_more_link?.textfield;
        banner.shop_now = data?.shop_now?.textfield;
        banner.shop_now_link = data?.shop_now_link?.textfield;
        banner.subtitle = data?.subtitle?.mantle_ct?.textarea?.value;
        banner.title = data?.title?.mantle_ct?.textarea?.value;

        return banner;
    }
}
